// components/FeedbackNavbar.js
import { Grid, Typography, Button, IconButton, Divider } from '@mui/material';
import React from 'react';
import { variants } from '../../../../variants/variants';
import {
  ArrowBackIosNewRounded,
  FeedbackRounded,
  Newspaper,
  PlayArrow,
  PlayCircle,
  PlayCircleFilled,
  PlayCircleOutline,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Theme } from 'emoji-picker-react';

const PublicNavbar = () => {
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    navigate('/auth');
  };

  return (
    <Grid
      item
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width="100%"
      sx={{ m: 1, borderBottom: 1, pb: 1, borderColor: 'divider' }}
    >
      <Grid item display={'flex'} justifyContent={'start'}>
        <IconButton
          id="backToHome"
          onClick={handleNavigateBack}
          sx={{
            p: 0,
            pr: 1,
            display: 'none',
            display: 'flex',
          }}
        >
          <ArrowBackIosNewRounded fontSize="small" />
        </IconButton>
        <Newspaper sx={variants.icon.active} />
        <Typography component={'div'} ml={1}>
          GNews{' '}
          <Typography fontSize={variants.BODY} sx={{ color: 'grey' }}>
            Gateway News Network
          </Typography>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default PublicNavbar;
